module.exports = __webpack_public_path__ + "img/couples-027.dc6a66b3.jpg";